(() => {
  window.swinger.eventHub.register('click', '.swinger-alphabet label', (e) => {
    const inputId = window.swinger.eventHub.getTarget(e).getAttribute('for');
    const input = document.getElementById(inputId);

    if (input.checked) {
      input.checked = false;
      window.swinger.eventHub.trigger(input, 'change');
      e.preventDefault();
    }
  });

  // #2543 allows for navigation without loosing params while changing alphabet
  window.swinger.eventHub.register('click', '.swinger-alphabet a', (e) => {
    const href = window.swinger.eventHub.getTarget(e).getAttribute('href');
    const params = new URLSearchParams(window.location.search).toString();
    if (params) {
      const hrefWithParams = `${href}?${params}`;
      window.location.href = hrefWithParams;
      e.preventDefault();
    }
  });
})();
